(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon/assets/javascripts/coupon-single-row-mobile.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon/assets/javascripts/coupon-single-row-mobile.js');
"use strict";

const {
  useContext
} = React;
const {
  useBranding
} = svs.components.tipsen.hooks;
const {
  DrawContext
} = svs.components.tipsen.drawProvider;
const {
  CouponSingleRowBetButtons,
  CouponSingleRow
} = svs.components.tipsen.coupon;
const {
  CouponSingelPixChoices
} = svs.components.tipsen.coupon;
const {
  useCurrentDraw
} = svs.components.tipsen.drawProvider.hooks;
const {
  getProductBrandByDraw
} = svs.components.lbUtils.brandMapping.fn;
const CouponSingelRowsMobile = _ref => {
  let {
    couponId,
    events,
    outcomeLabels,
    radioRefs,
    selectedBoard,
    selections
  } = _ref;
  const draw = useCurrentDraw();
  const brandingList = useBranding();
  const brandingByDraw = getProductBrandByDraw(draw);
  const branding = brandingByDraw || brandingList[brandingList.length - 1] || brandingList[0] || 'sport';
  const {
    productId,
    drawNumber
  } = useContext(DrawContext);
  const mappedBoards = [];
  events.forEach(() => {
    mappedBoards.push(outcomeLabels);
  });
  const getFullRowDescription = () => {
    const isComplete = selections[selectedBoard].every(match => match.some(outcome => outcome === true));
    if (isComplete) {
      return "Rad ".concat(selectedBoard + 1, ", fullst\xE4ndigt ifylld.");
    }
    const isPartial = !isComplete && selections[selectedBoard].some(match => match.some(outcome => outcome === true));
    if (isPartial) {
      return "Rad ".concat(selectedBoard + 1, ", delvis ifylld.");
    }
    return "Rad ".concat(selectedBoard + 1, ", ej p\xE5b\xF6rjad");
  };
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "coupon-single-rows"
  }, React.createElement("div", {
    className: "coupon-single-rows-event-column"
  }, events.map(drawEvent => React.createElement(CouponSingleRow, {
    branding: branding,
    drawNumber: drawNumber,
    event: drawEvent,
    isSingleRowForSmallDevice: true,
    key: drawEvent.eventNumber,
    productId: productId
  }))), React.createElement("div", {
    className: "coupon-single-rows-board"
  }, React.createElement("section", {
    "aria-label": getFullRowDescription(),
    id: "row-".concat(selectedBoard + 1)
  }, mappedBoards.map((_, eventIndex) => {
    const selectedIndex = selections[selectedBoard][eventIndex].findIndex(outcome => outcome);
    const key = "".concat(selectedBoard + 1, "_").concat(eventIndex + 1);
    return React.createElement("div", {
      className: "coupon-single-rows-bet-buttons",
      key: key
    }, React.createElement(CouponSingleRowBetButtons, {
      boardIndex: selectedBoard,
      couponId: couponId,
      eventIndex: eventIndex,
      numOfBoards: 1,
      numOfEvents: events.length,
      outcomeLabels: outcomeLabels,
      radioRefs: radioRefs,
      selectedIndex: selectedIndex,
      selections: selections
    }));
  })))), React.createElement(CouponSingelPixChoices, {
    boardIndex: selectedBoard,
    couponId: couponId
  }));
};
setGlobal('svs.components.tipsen.coupon.CouponSingelRowsMobile', CouponSingelRowsMobile);

 })(window);